export const errorMessages = [
  {
    app: 'simplifiedreg',
    errorKey: 'otpResend',
    errorValue:
      'A new verification code has been sent to your email address, $email. This code will expire in $expTime minutes.',
  },
  {
    app: 'simplifiedreg',
    errorKey: 'otpMaxtimesSent',
    errorValue:
      'You have exceeded the number of new verification codes we allow you to send to yourself. To complete your account setup, use the verification code that was last sent to you or call $tel.',
  },
  {
    app: 'simplifiedreg',
    errorKey: 'otpMismatch',
    errorValue:
      'The code you entered does not match the verification code we sent you. Please try again.',
  },
  {
    app: 'simplifiedreg',
    errorKey: 'otpExpired',
    errorValue:
      'The last verification code we sent to you has expired. Please send yourself a new verification code and try again.',
  },
  {
    app: 'simplifiedreg',
    errorKey: 'requiredField',
    errorValue: 'Cannot be left blank.',
  },
  {
    app: 'simplifiedreg',
    errorKey: 'wentWrong',
    errorValue: 'Something went wrong!',
  },
];
